<template>
  <!-- CTA Sections > Simple justified -->
  <div class="bg-white border-t border-gray-300">
    <div class="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:flex lg:items-center lg:justify-between lg:px-8">
      <h2 class="text-4xl font-bold tracking-tight text-gray-900">
        Sofort voller Zugriff zum Studio Pro.<br />
        Nach dem Probemonat geht es<br />
        automatisch im Basic-Plan weiter.
      </h2>
      <div class="mt-10 flex items-center gap-x-6 lg:mt-0 lg:flex-shrink-0">
        <router-link  :to="{name: 'setup'}" class="rounded-md bg-teal-700 px-3.5 py-1.5 text-base font-semibold leading-7 text-white shadow-sm hover:bg-teal-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-700">
          Los geht's
        </router-link>
        <a href="#antworten" class="text-base font-semibold leading-7 text-gray-900">
          Häufige Fragen <span aria-hidden="true">&#x2193;</span>
        </a>
      </div>
    </div>
  </div>
</template>
